<template>
  <div class="jobs-navBar flex-between" v-if="loadingOver">
    <div class="nav-list flex-start">
      <router-link tag="a" v-for="item in navData" :key="item.value" class="nav-item flex-column-center"
                   :to="item.link">{{ item.text }}
      </router-link>
    </div>
    <div class="jobs-operation">
      <div class="search-container flex-between" v-if="searchShow" @click="toSearch">
        <span class="search-text">职位搜索</span>
        <span class="iconfont iconsearch" />
      </div>
      <!--      <span @click="toSearch" class="iconfont iconsearch" v-if="searchShow"/>-->
      <!--      <span @click="changeMoreState" class="iconfont icongrid"/>-->
      <!--      <job-more-info v-show="moreState" @handleClose="changeMoreState"/>-->
    </div>
  </div>
</template>

<script>
	import { mapActions, mapState } from 'vuex'
	import jobMoreInfo from './job-more-info'
	import { envMixin } from '../../assets/js/mixin/global'
	import { userMixin } from '../../assets/js/mixin/user'

	export default {
		name: 'jobs-navBar',
		mixins: [ envMixin, userMixin ],
		props: {
			currentTag: {
				type: String,
				default: 'recommend'
			}
		},
		data () {
			return {
				loadingOver: false,
				moreState: false,
				navData: [
					{ text: '推荐', value: 'recommend', link: '/jobs/recommend' },
					// { text: '校招', value: 'campus', link: '/jobs/campus' },
					// { text: '领英职位', value: 'linkIn', link: '/in_recruit_infos/my_in_infos' },
				]
			}
		},
		mounted () {
			this.verifyIdentity()
		},
		computed: {
			searchShow () {
				return this.$route.path !== '/in_recruit_infos/my_in_infos'
			},
      showNav(){
			  let nav = this.userData.is_student? [
          { text: '推荐', value: 'recommend', link: '/jobs/recommend' },
          { text: '校招', value: 'campus', link: '/jobs/campus' }
        ]:[
          { text: '推荐', value: 'recommend', link: '/jobs/recommend' }
        ]
			  return nav
      }
		},
		watch: {},
		components: {
			jobMoreInfo
		},
		methods: {
			async verifyIdentity () {
				if (!Object.keys(this.userData).length) await this.getUserData()
				this.loadingOver = true
			},
			toSearch () {
        if (this.iosOrAndroid) {
          window.location.href = '/recruit_infos/search'
        } else {
          this.$fn.jump(
            `${window.location.origin}/jobs/recommend/search`,
            () => {
              this.$router.push(`/jobs/recommend/search`)
            }
          )
        }
			},
			changeMoreState () {
				this.moreState = !this.moreState
			}
		}
  }
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/global/variable';
  .jobs-navBar {
    height: 44px;
    padding: 0 24px;
    /*border-bottom: 1px solid #ECECEC;*/
    background-color: $color-light;
    .nav-list {
      .nav-item {
        margin-right: 32px;
        font-size: $font-size-medium-x;
        color: #9C9C9C;
        &:last-child {
          margin-right: 0;
        }
      }
      .router-link-active {
        display: flex;
        flex-direction: column;
        align-items: center;
        color: $color-title;
        font-weight: 500;
        &::after {
          //position: absolute;
          //bottom: -14px;
          content: '';
          display: inline-block;
          width: 12px;
          height: 2px;
          border-radius: 2px;
          background-color: $color-theme;
          margin-top: 6px;
          margin-bottom: -8px;
        }
      }
    }
    .jobs-operation {
      .search-container {
        width: 144px;
        height: 30px;
        padding: 9px 16px;
        border-radius: 16px;
        background-color: #F9F9F9;
        .search-text {
          font-size: $font-size-small;
          color: #9c9c9c;
        }
      }
      .iconfont {
        color: #9C9C9C;
        font-weight: bold;
      }
    }
  }
</style>
